var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plat-produit-multiples',{attrs:{"canAddFromArbo":_vm.canAddFromArbo,"plat":_vm.plat,"forceQuantifiable":true,"platSectionId":_vm.platSectionId,"platArboId":_vm.platArboId},on:{"addToCart":_vm.addToCart}})}
var staticRenderFns = []

export { render, staticRenderFns }